import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import { AppBar, Box, Tab, Tabs, Typography } from "@mui/material";
import "./TabsComponent.css";

function normalizeKey(key) {
    if (key === null || key === undefined) return '';
    return String(key).replace(/^\.\$/, '');
}

function TabPanel(props) {
    const { children, value, index, className } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            className={className}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `wrapped-tab-${index}`,
        'aria-controls': `wrapped-tabpanel-${index}`,
    };
}

export default function TabsComponent(props) {
    const color = props.color ? props.color : '#57A585';
    const screenReducer = useSelector(state => state.ScreenReducer);
    const [isTall, setIsTall] = React.useState(true);

    const tabs = props.tabs ? props.tabs : [];
    const tab = props.tab ? props.tab : '';
    const tabPanels = Array.isArray(props.children) ? props.children : [props.children];

    const [value, setValue] = React.useState(props.tabDefault ? props.tabDefault : '');
    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (props.onChange) props.onChange(newValue);
    };

    useEffect(() => {
        if (tab) setValue(tab);
    }, [tab]);

    useEffect(() => {
        if (screenReducer.screen) {
            const isTallScreen = (screenReducer.screen === 'MD' || screenReducer.screen === 'LG' || screenReducer.screen === 'XL');
            if (isTallScreen !== isTall) setIsTall(isTallScreen);
        }
    }, [screenReducer.screen, isTall]);

    return (
        <div className={`tabs-component ${!isTall ? 'tabs-component-small' : ''} ${props.className ? props.className : ''}`} style={props.style}>
            <AppBar position="static">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    centered={props.centered}
                    TabIndicatorProps={{ style: { background: color } }}
                    sx={{
                        '& .MuiTab-root.Mui-selected': {
                            color: color,
                        },
                    }}
                >
                    {tabs
                        .filter((item) => !item.hidden)
                        .map((item) => (
                            <Tab
                                key={item.key}
                                {...a11yProps(item.key)}
                                value={item.key}
                                label={item.label}
                                disabled={item.disabled}
                                wrapped={item.wrapped}
                            />
                        ))}
                </Tabs>
            </AppBar>

            {tabPanels.map((tabPanel, key) => {
                if (!tabPanel) return null;
                const panelKey = normalizeKey(tabPanel.key);
                return (
                    <TabPanel key={key} className="tabs-panel" value={normalizeKey(value)} index={panelKey}>
                        {tabPanel}
                    </TabPanel>
                );
            })}
        </div>
    );
}

